import { useMemo } from 'react'
import type { ListGamesInfoQuery } from '../../generated/graphql'
import { useListGamesInfoQuery } from '../../generated/graphql'
import { isGameAvailable } from '../../services/auth/permissions/permissions'
import useAuth from '../../services/auth/useAuth'

export type GamesList = ListGamesInfoQuery['listGames']

const useGames = (showAll = false) => {
  const { user } = useAuth()
  const { data } = useListGamesInfoQuery(undefined, {
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  })
  const games = useMemo(() => data?.listGames || [], [data])
  const visibleGames = useMemo(() => {
    if (showAll) return games

    return games.filter((game) => isGameAvailable(user, game.id))
  }, [games, showAll, user])

  return visibleGames
}

export default useGames
